import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async voltarEntradaBloqueada(api, parametros) {
    parametros.operacao = 'voltarEntradaBloqueada';

    let retorno = {};

    await api.santriPOST('/rest/entrada', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REntrada/REntradaVoltarEntradaBloqueada.js